import { UiTypography } from '@/components/ui/Typography';
import { StripeV2SubscriptionPrice } from '@/services/stripe/dto';

import { BillingTermsWithCheckbox } from '../BillingTermsWithCheckbox';

export function MonthlyRebillDescriptionAgreement({
  selectedPlan,
}: {
  selectedPlan: StripeV2SubscriptionPrice;
}) {
  return (
    <UiTypography
      variant="body-small"
      color="neutral-black"
      align="center"
      className="local-description"
    >
      <BillingTermsWithCheckbox>
        I agree that I will be automatically charged ${selectedPlan.price} after
        the payment confirmation. The subscription will then be auto-renewed
        monthly after a 1-month intro offer at the full price of $
        {selectedPlan.original_price}. Payments are charged in USD, excluding
        taxes.
      </BillingTermsWithCheckbox>
    </UiTypography>
  );
}

